var angular = require('angular');
var _module = require('../../components/module.js');
var $ = require('jquery');

_module.service('$fsloading', [
    '$compile',
    '$rootScope',

    function ($compile, $rootScope) {
        function FullscreenLoading() {
            this.template = $compile(require('./index.html'))($rootScope.$new());
            this.isOpen = false;
        }

        /*
        Shows the loading message

        @function show
         */

        FullscreenLoading.prototype.show = function () {
            if(this.isOpen) return;

            $('body').append(this.template);
            this.isOpen = true;
        };

        /*
        Hides the loading message

        @function hide
         */

        FullscreenLoading.prototype.hide = function () {
            if(!this.isOpen) return;

            $('#FullscreenLoading').remove();
            this.isOpen = false;
        };

        return new FullscreenLoading();
    }
]);
